import { Users } from 'lucide-react';
import { PlaceholderPage } from '../PlaceholderPage';

export function ReviewersPage() {
  return <PlaceholderPage title="Reviewers" session={9} icon={Users} />;
}
